'use client';

import React from 'react';
import ToastContainer from './ToastContainer';

const ClientToastContainer = () => {
  return <ToastContainer />;
};

export default ClientToastContainer;